module.exports = __webpack_public_path__ + "static/media/S3N13-6.30045337.svg";